import { InventoryTag } from '../types/inventory';

export const NEW_TAG_DRAFT_PREFIX = 'new:';

export function normalizeTagNameKey(name: string): string {
    return name.trim().toLowerCase();
}

export function tagNamesHasName(names: Array<string>, name: string): boolean {
    const key = normalizeTagNameKey(name);
    if (!key) return false;
    return names.some((n) => normalizeTagNameKey(n) === key);
}

export function tagListHasName(tags: Array<InventoryTag>, name: string): boolean {
    return tagNamesHasName(
        tags.map((t) => t.name),
        name,
    );
}

export function draftInventoryTag(name: string): InventoryTag {
    const trimmed = name.trim();
    return { _id: `${NEW_TAG_DRAFT_PREFIX}${trimmed}`, name: trimmed, isNew: true };
}

/** Case-insensitive dedupe; keeps the first spelling seen. */
export function dedupeTagNames(names: Array<string>): Array<string> {
    const seen = new Set<string>();
    const result: Array<string> = [];
    for (const raw of names) {
        const trimmed = raw.trim();
        const key = normalizeTagNameKey(trimmed);
        if (!key || seen.has(key)) continue;
        seen.add(key);
        result.push(trimmed);
    }
    return result;
}

export function appendTagIfMissing(
    tags: Array<InventoryTag>,
    name: string,
): Array<InventoryTag> {
    const trimmed = name.trim();
    if (!trimmed || tagListHasName(tags, trimmed)) return tags;
    return [...tags, draftInventoryTag(trimmed)];
}

export function appendTagNameIfMissing(names: Array<string>, name: string): Array<string> {
    const trimmed = name.trim();
    if (!trimmed) return names;
    if (tagNamesHasName(names, trimmed)) return names;
    return [...names, trimmed];
}
